import React from 'react';
import Button from '../../../generic-components/Button';

interface ISendMoneyWizardFooter {
  title: string;
  onClick: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  secondaryButton?: React.ReactNode;
}

const STYLES = {
  WRAPPER:
    'w-full flex items-center justify-center py-[24px] border-t border-bw03 fadeIn fixed bottom-0 z-[9999] bg-bw00',
  BUTTON: 'max-w-[100%] h-[54px] text-md text-bw00 rounded font-metricRMedium',
  BUTTON_ACTIVE: 'bg-action03 hover:bg-action04 active:bg-action04',
  BUTTON_DISABLED: 'bg-bw05',
};

const SendMoneyWizardFooter = ({
  isLoading,
  disabled,
  onClick,
  title,
  className,
  secondaryButton,
}: ISendMoneyWizardFooter) => (
  <div className={STYLES.WRAPPER}>
    {secondaryButton}
    <Button
      isLoading={isLoading}
      onClick={onClick}
      disable={disabled}
      title={title}
      className={`${className} ${disabled ? STYLES.BUTTON_DISABLED : STYLES.BUTTON_ACTIVE} ${STYLES.BUTTON}`}
      id=''
      testId='sendMoneyFooterMainButton'
    />
  </div>
);

export default SendMoneyWizardFooter;
